var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0002C2 12.9393 2.34362 12.2496 3 11.4995C3.65638 10.7493 4.54663 10.3279 5.47489 10.3279H12.4749C13.4032 10.3279 14.2934 10.7493 14.9498 11.4995C15.6062 12.2496 16.0001 12.9393 16.0001 14.0002C16.0001 14.5306 15.8157 15.0394 15.4875 15.4144C15.1593 15.7895 14.7142 16.0002 14.2501 16.0002H3.75001C3.28588 16.0002 2.84076 15.7895 2.51257 15.4144C2.18438 15.0394 2 14.5306 2 14.0002Z",
    stroke: "#435869",
    strokeWidth: 1.33,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 8.00003C10.6569 8.00003 12 6.65688 12 5.00001C12 3.34315 10.6569 2 9.00001 2C7.34315 2 6 3.34315 6 5.00001C6 6.65688 7.34315 8.00003 9.00001 8.00003Z",
    stroke: "#435869",
    strokeWidth: 1.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/icProfile.481d9892d1dab446d00c61b299c893e6.svg";
export { ForwardRef as ReactComponent };